/* Quick-add on collection cards.

   An always-visible basket icon on each product card. Clicking it opens a
   "בחר מידה:" panel; clicking a size adds that variant straight to the cart
   and opens the cart drawer.

   Sibling color integration: if the card has sibling color swatches and one
   is currently previewed (.product-block-options__item--active), the sizes
   are read from that swatch's data-sibling-sizes, so the add-to-cart always
   targets the color the shopper is looking at.
*/
(function () {
  if (window.customElements && window.customElements.get('quick-add')) return;

  class QuickAdd extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.quick-add__toggle');
      this.panel = this.querySelector('.quick-add__panel');
      this.sizesCont = this.querySelector('.quick-add__sizes');
      this.closeBtn = this.querySelector('.quick-add__close');
      if (!this.toggle || !this.panel || !this.sizesCont) return;

      this.toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (this.panel.hidden) this.open(); else this.close();
      });
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      }
      // Close when clicking anywhere outside the card's panel
      this.onDocClick = (e) => {
        if (!this.panel.hidden && !this.contains(e.target)) this.close();
      };
      document.addEventListener('click', this.onDocClick);

      this.sizesCont.addEventListener('click', (e) => {
        const btn = e.target.closest('.quick-add__size');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        this.addToCart(btn);
      });
    }

    disconnectedCallback() {
      if (this.onDocClick) document.removeEventListener('click', this.onDocClick);
    }

    currentSizes() {
      const card = this.closest('.product-block');
      const activeSibling = card
        && card.querySelector('.product-block-options__item--sibling.product-block-options__item--active[data-sibling-sizes]');
      const raw = activeSibling
        ? activeSibling.getAttribute('data-sibling-sizes')
        : this.getAttribute('data-sizes');
      try {
        return JSON.parse(raw || '[]');
      } catch (err) {
        return [];
      }
    }

    open() {
      const sizes = this.currentSizes();
      this.sizesCont.innerHTML = '';
      sizes.forEach((s) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quick-add__size';
        btn.textContent = s.size;
        btn.dataset.variantId = s.id;
        if (!s.available) {
          btn.disabled = true;
          btn.classList.add('quick-add__size--soldout');
        }
        this.sizesCont.appendChild(btn);
      });
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      // Close any other open quick-add panels
      document.querySelectorAll('quick-add').forEach((qa) => {
        if (qa !== this) qa.close();
      });
    }

    close() {
      if (!this.panel || this.panel.hidden) return;
      this.panel.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
    }

    async addToCart(btn) {
      if (this.busy) return;
      this.busy = true;
      btn.classList.add('quick-add__size--loading');
      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 })
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        this.close();
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
        const drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(this.toggle);
      } catch (err) {
        btn.classList.add('quick-add__size--error');
        setTimeout(() => btn.classList.remove('quick-add__size--error'), 1500);
      } finally {
        btn.classList.remove('quick-add__size--loading');
        this.busy = false;
      }
    }
  }

  window.customElements.define('quick-add', QuickAdd);
})();
